<app-header></app-header>
<app-loader *ngIf="isButtonLoader" isAlertDialog="true"></app-loader>

<div class="wrapper">

    <app-estimate-box [isLoader]="isLoader" [showBack]="false" [showForward]="false" [submitBtnLabel]="'Continue'"
        (submitBtnClick)="getMlsServices()"></app-estimate-box>

    <div class="section_wrapper" style="margin-top: 20px;">
        <div class="dashBoard plan_Add">
            <app-stepper currentIndex="2" class="stepper"></app-stepper>
            <div class="plans_addon w_100" *ngIf="!isButtonLoader">
                <h3 class="font_40_a32">Plan and Add-Ons</h3>
                <table class="table_web {{selectedPlanClass}}">
                    <thead>
                        <th class="core_name">Core Features</th>
                        <th *ngFor="let plan of plans;let i = index;" class="font_24_a32_600">
                            <div class="table_heading">
                                <p>
                                    <span class="font_20_a32_500 plan_name">{{plan.name}}</span>
                                    <br>
                                    <span class="font_40_a32 plan_price"> ${{plan.price | number}}*</span>
                                    <br>
                                    <span class="plan_settlement" *ngIf="plan.settlement">{{plan.settlement}}
                                    </span>
                                </p>
                                <div class="choose_plan_cell choose_Checkbox">
                                    <button (click)="learnMore()" *ngIf="i == plans.length-1"
                                        class="outlinedLearn">Learn More</button>
                                    <app-checkbox [isOutlined]="true" *ngIf="i != plans.length-1"
                                        [label]="'Choose plan'" [checked]="plan.isSelected"
                                        (checkedChange)="onCheckboxChange($event,plan.packageid)"></app-checkbox>
                                </div>
                            </div>
                        </th>
                    </thead>
                    <tbody>


                        <tr *ngFor="let feature of features">
                            <th class="feature_name" [innerHTML]="convertToHtml( feature.text)">
                            </th>
                            <td class="table_cell" *ngIf="feature['1']">
                                <img *ngIf="feature['1'].imageUrl" src="{{feature['1'].imageUrl}}" alt="">
                                <p *ngIf="!feature['1'].imageUrl" [innerHTML]="convertToHtml(feature['1'].content)">
                                </p>
                            </td>
                            <td class="table_cell" *ngIf="feature['2']">
                                <img *ngIf="feature['2'].imageUrl" src="{{feature['2'].imageUrl}}" alt="">
                                <p *ngIf="!feature['2'].imageUrl" [innerHTML]="convertToHtml(feature['2'].content)"></p>
                            </td>
                            <td class="table_cell" *ngIf="feature['3']">
                                <img *ngIf="feature['3'].imageUrl" src="{{feature['3'].imageUrl}}" alt="">
                                <p *ngIf="!feature['3'].imageUrl" [innerHTML]="convertToHtml(feature['3'].content)"></p>
                            </td>
                            <td class="table_cell" *ngIf="feature['4']">
                                <img *ngIf="feature['4'].imageUrl" src="{{feature['4'].imageUrl}}" alt="">
                                <p *ngIf="!feature['4'].imageUrl" [innerHTML]="convertToHtml(feature['4'].content)"></p>
                            </td>
                        </tr>

                        <tr>
                            <td></td>
                            <td *ngFor="let plan of plans;let i = index;" class="choose_plan_cell">
                                <button (click)="learnMore()" *ngIf="i == plans.length-1" class="outlinedLearn">Learn
                                    More</button>
                                <app-checkbox [isOutlined]="true" [label]="'Choose plan'" [checked]="plan.isSelected"
                                    (checkedChange)="onCheckboxChange($event,plan.packageid)"
                                    *ngIf="i != plans.length-1"></app-checkbox>
                            </td>
                        </tr>
                    </tbody>
                </table>

                <br>
                <app-green-button-v2 *ngIf="isScreenWidthLarge && !isLoader" [buttonType]="'submit'"
                    (click)="getMlsServices()" class="create_button" label="Continue" [width]="'200px'"
                    [height]="'47px'">
                </app-green-button-v2>


                <div class="carousel-wrap mobile_tab" #scrollContainer>
                    <div class="carousel-item" *ngFor="let plan of plans;let i = index;">
                        <div class="item-wrap" [style.width.px]="viewportWidth>600?500:viewportWidth - 150">
                            <div class="item-padd">
                                <div class="justify_space_bt" style="gap: 20px;">
                                    <h6 class="mobile-plane-name">{{plan.name}}</h6>
                                    <p class="mobile_price"> ${{plan.price | number}}*</p>
                                    <span class="plan_settlement" *ngIf="plan.settlement">{{plan.settlement}}
                                    </span>
                                </div>

                                <app-checkbox class="mobile_choose_plan_btn" width="120px" height="40px"
                                    [isOutlined]="true" [label]="'Choose plan'" [checked]="plan.isSelected"
                                    (checkedChange)="onCheckboxChange($event,plan.packageid)"
                                    *ngIf="i != plans.length-1"></app-checkbox>

                                <button (click)="learnMore()" *ngIf="i == plans.length-1" class="outlinedLearn">Learn
                                    More</button>
                            </div>
                            <div>
                                <div class="feature_table">
                                    <div>
                                        <p class="feature_text_mobile" style="font-weight: 700;">Features</p>
                                    </div>
                                    <div *ngFor="let feature of mobFeatures[i]">
                                        <p class="feature_text_mobile" [innerHTML]="convertToHtml( feature)"></p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="brocker_values" *ngIf="brokerageValues">
                    <p>
                        Broker and Brokerage licensed in : <span>{{stateName}}</span> <br>
                        Broker Lic : <span>{{brokerageValues.brokerLicenseNo}}</span> <br>
                        Brokerage Lic : <span> {{brokerageValues.brokerageLicenseNo}}</span>
                    </p>
                    <p class="selected_text font_16_a32_700" *ngIf="selectedPlan">
                        YOU HAVE SELECTED {{selectedPlan.name}} ${{selectedPlan.price}} PLAN
                    </p>

                </div>

                <div class="mobile_submitButtons">

                    <app-green-button-v2 class="SumbitBtnRes" (click)="getMlsServices()" label="Continue"
                        [buttonType]="'submit'" [width]="'136px'" [height]="'50px'">
                    </app-green-button-v2>
                    <app-loader class="loader_wrap" *ngIf="isLoader"></app-loader>

                </div>

            </div>
        </div>
    </div>

</div>